import { Controller } from "stimulus";

export default class extends Controller {

  static targets = [ "passwordField" ]

  password(e) {
    if (this.passwordFieldTarget.type === "password") {
      this.passwordFieldTarget.type = "text";
    } else {      
      this.passwordFieldTarget.type = "password";
    }
    e.target.classList.toggle("active");
  }
}